export default __webpack_public_path__ + "static/media/mempad-logo.f0229759.svg";